<template>
    <div class="kpi-highlight-card">
      <div class="kpi-left">
        <h2 class="kpi-number">{{ animatedValue.toLocaleString() }}</h2>
        <p class="kpi-label">{{ title }}</p>
      </div>
      <div class="kpi-right">
        <div class="pulse-dot"></div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'KPIHighlight',
    props: {
      title: {
        type: String,
        default: 'Total Candidates Participated'
      },
      value: {
        type: Number,
        required: true
      }
    },
    watch: {
      value: {
        immediate: true,
        handler(newVal) {
          let start = 0
          const end = newVal
          const duration = 800
          const frameRate = 20
          const increment = (end - start) / (duration / frameRate)
  
          const interval = setInterval(() => {
            start += increment
            if (start >= end) {
              start = end
              clearInterval(interval)
            }
            this.animatedValue = Math.floor(start)
          }, frameRate)
        }
      }
    },
    data() {
      return {
        animatedValue: 0
      }
    },
  }
  </script>
  
  <style scoped>
  .kpi-highlight-card {
    flex: 1 1 48%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(145deg, #ffffff, #f0f0f0);
    border-radius: 20px;
    padding: 24px 32px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.06);
    transition: transform 0.3s ease;
  }
  
  .kpi-highlight-card:hover {
    transform: translateY(-4px);
  }
  
  .kpi-left {
    display: flex;
    flex-direction: column;
  }
  
  .kpi-number {
    font-size: 40px;
    font-weight: bold;
    color: #3f51b5;
    margin: 0;
  }
  
  .kpi-label {
    margin: 6px 0 0;
    font-size: 16px;
    color: #777;
  }
  
  .kpi-right {
    position: relative;
    width: 40px;
    height: 40px;
  }
  
  .pulse-dot {
    width: 16px;
    height: 16px;
    background: #3f51b5;
    border-radius: 50%;
    animation: pulse 1.4s infinite ease-in-out;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  
  @keyframes pulse {
    0% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
    100% {
      transform: translate(-50%, -50%) scale(2.5);
      opacity: 0;
    }
  }
  </style>
  